import { docReady } from '../helpers/doc-ready';
docReady(() => {
    const copyButtons = document.querySelectorAll('[data-copy]');
    copyButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const toolTip = button.querySelector('[data-copy-tooltop]');
            const copyString = button.getAttribute('data-copy-content');
            if (copyString) {
                toolTip.innerHTML = 'Copied: ' + copyString;
                navigator.clipboard.writeText(copyString);
                setTimeout(() => {
                    toolTip.innerHTML = 'Copy to clipboard';
                }, 750);
            }
        });
    });
});
